export const Platform = {
  VIDEO: 'Video',
  AUDIO: 'Audio'
} as const;
export type PlatformType = (typeof Platform)[keyof typeof Platform];
export const PLATFORMS: PlatformType[] = [Platform.VIDEO, Platform.AUDIO];

// The lambda's `platform` param: video placements are stored under "streaming".
export const PLATFORM_PARAM: Record<PlatformType, string> = {
  [Platform.VIDEO]: 'streaming',
  [Platform.AUDIO]: 'audio'
};

export const BRANCH = 'v4';

// The lambda returns null for a metric when the model has no prediction for the placement.
export interface StageTwoRow {
  placement: string;
  devcatos?: string;
  pred_cr_per_m?: number | null;
  cpm: number | null;
  pred_cost_per_conversion?: number | null;
  pred_cr_per_dollar?: number | null;
  is_seen: string;
}

export interface StageTwoData {
  rows: StageTwoRow[];
  kpi: string;
  stageTwoFileTimeStamp: string;
}

export interface DisplayRow extends StageTwoRow {
  display_name: string;
}

export const CSV_COLUMNS: (keyof StageTwoRow)[] = [
  'placement',
  'pred_cr_per_m',
  'cpm',
  'pred_cost_per_conversion',
  'pred_cr_per_dollar'
];
export const CSV_COLUMNS_WITH_DEVOSCAT: (keyof StageTwoRow)[] = [
  'placement',
  'devcatos',
  ...CSV_COLUMNS.slice(1)
];

// The CDN names device images differently from the DevOSCat values.
export const DEVOSCAT_IMAGES: Record<string, string> = {
  LAPTOP: 'DESKTOP',
  MOBILE: 'PHONE',
  CTV: 'TV'
};
